import { mock, intercepter } from '../config';

mock.mock('/auth/logout', 'post', intercepter(null));
